// extracted by mini-css-extract-plugin
module.exports = {"widthContainerCompensator":"_2MIK6E"};